export const userLocationAssignmentKeys = {
    all: ['user-location-assignment'] as const,
    details: () => [...userLocationAssignmentKeys.all, 'detail'] as const,
    detail: (userId: string) => [...userLocationAssignmentKeys.details(), userId] as const,
    /**
     * The unscoped L1 catalog the assignment dialog picks from. Deliberately not under `locationKeys`:
     * that namespace is being reworked for the scoped `by_user` read (POC-21832), and this catalog must
     * stay unscoped (TDR-018 Decision 4).
     */
    locationCatalog: () => [...userLocationAssignmentKeys.all, 'location-catalog'] as const,
};
